import React from 'react';
function Padlock({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={stroke}
      stroke="none"
      {...otherProps}
    >
      <path
        d="M16.5 10H16V8C16 5.794 14.206 4 12 4C9.794 4 8 5.794 8 8V10H7.5C6.67333 10 6 10.6727 6 11.5V18.5C6 19.3273 6.67333 20 7.5 20H16.5C17.3267 20 18 19.3273 18 18.5V11.5C18 10.6727 17.3267 10 16.5 10ZM9.33333 8C9.33333 6.52933 10.5293 5.33333 12 5.33333C13.4707 5.33333 14.6667 6.52933 14.6667 8V10H9.33333V8ZM12.6667 15.148V16.6667C12.6667 17.0347 12.3687 17.3333 12 17.3333C11.6313 17.3333 11.3333 17.0347 11.3333 16.6667V15.148C10.9367 14.9167 10.6667 14.4913 10.6667 14C10.6667 13.2647 11.2647 12.6667 12 12.6667C12.7353 12.6667 13.3333 13.2647 13.3333 14C13.3333 14.4913 13.0633 14.9167 12.6667 15.148Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Padlock;
